// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-capture-card {
  margin-top: 20px;
  text-align: center;
}

.email-capture-card h3 {
  margin-top: 0;
  margin-bottom: 8px;
  color: #1c4f8a;
  font-size: 1.05rem;
}

.email-capture-sub {
  font-size: 0.9rem;
  color: #556;
  margin-bottom: 16px;
}

.email-capture-form {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.email-capture-input {
  flex: 1 1;
  min-width: 220px;
  max-width: 340px;
  padding: 10px 14px;
  border: 1px solid #ccd;
  border-radius: 6px;
  font-size: 0.95rem;
  outline: none;
}

.email-capture-input:focus {
  border-color: #1c4f8a;
  box-shadow: 0 0 0 2px rgba(28, 79, 138, 0.15);
}

.email-capture-btn {
  padding: 10px 22px;
  background: #1c4f8a;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.email-capture-btn:hover:not(:disabled) {
  background: #163d6e;
}

.email-capture-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.email-capture-error {
  color: #d32f2f;
  font-size: 0.85rem;
  margin-top: 8px;
}

.email-capture-privacy {
  font-size: 0.78rem;
  color: #888;
  margin-top: 10px;
  margin-bottom: 0;
}

.email-capture-privacy a {
  color: #1c4f8a;
}

.email-capture-success {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
}

.email-capture-check {
  font-size: 1.6rem;
}

.email-capture-success p {
  margin: 0;
  font-size: 0.95rem;
  color: #334;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/EmailCapture.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".email-capture-card {\n  margin-top: 20px;\n  text-align: center;\n}\n\n.email-capture-card h3 {\n  margin-top: 0;\n  margin-bottom: 8px;\n  color: #1c4f8a;\n  font-size: 1.05rem;\n}\n\n.email-capture-sub {\n  font-size: 0.9rem;\n  color: #556;\n  margin-bottom: 16px;\n}\n\n.email-capture-form {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.email-capture-input {\n  flex: 1;\n  min-width: 220px;\n  max-width: 340px;\n  padding: 10px 14px;\n  border: 1px solid #ccd;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  outline: none;\n}\n\n.email-capture-input:focus {\n  border-color: #1c4f8a;\n  box-shadow: 0 0 0 2px rgba(28, 79, 138, 0.15);\n}\n\n.email-capture-btn {\n  padding: 10px 22px;\n  background: #1c4f8a;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.email-capture-btn:hover:not(:disabled) {\n  background: #163d6e;\n}\n\n.email-capture-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.email-capture-error {\n  color: #d32f2f;\n  font-size: 0.85rem;\n  margin-top: 8px;\n}\n\n.email-capture-privacy {\n  font-size: 0.78rem;\n  color: #888;\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n\n.email-capture-privacy a {\n  color: #1c4f8a;\n}\n\n.email-capture-success {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: center;\n}\n\n.email-capture-check {\n  font-size: 1.6rem;\n}\n\n.email-capture-success p {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #334;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
